import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import theme from '@/config/theme';
import { AdminLogger } from '@/utils/logger';
import { LinearGradient } from 'expo-linear-gradient';

interface Props {
  title: string;
  value: string | number;
  onPress?: () => void;
  colors?: [string, string];
  /** Se true, indica que este KPI está ativo no filtro atual */
  selected?: boolean;
}

export default function KPIResumeCard({ title, value, onPress, colors, selected = false }: Props) {
  const log = AdminLogger.KPI;
  log.info('🧮 Render KPIResumeCard', { title, value });
  const PressableContainer = onPress ? TouchableOpacity : View;

  const handlePress = () => {
    log.info('KPI card pressed', { title });
    onPress?.();
  };

  return (
    <PressableContainer style={styles.wrapper} onPress={handlePress as any}>
      <LinearGradient
        /*
         * Se o cartão estiver selecionado, intensificamos a cor aplicando a versão "dark" do
         * gradiente padrão (ou a cor original se já foi passada explicitamente pelo caller).
         */
        colors={
          selected
            ? (
                colors ?? ([theme.colors.primary.dark, theme.colors.primary.default] as [string, string])
              )
            : colors ?? ([...theme.colors.primary.gradient] as [string, string])
        }
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={[styles.card, selected && styles.cardSelected]}
      >
        <Text style={styles.title}>
          {title}
        </Text>
        <Text style={styles.value}>{value}</Text>

        {selected && (
          <Text style={styles.hint}>Clique novamente para limpar</Text>
        )}
      </LinearGradient>
    </PressableContainer>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    margin: 4,
    flex: 1,
    minWidth: 0,
  },
  card: {
    paddingVertical: 10,
    paddingHorizontal: 4,
    borderRadius: theme.borderRadius.md,
    alignItems: 'center',
    justifyContent: 'center',
    //minHeight: 120,
    //flex: 1,
    ...theme.shadows.sm,
  },
  cardSelected: {
    /* Um leve aumento e borda para reforçar o destaque */
    transform: [{ scale: 1.03 }],
    borderWidth: 2,
    borderColor: theme.colors.primary.dark,
  },
  title: {
    fontSize: theme.fontSizes.xs,
    color: theme.colors.text.inverse,
    marginBottom: 4,
    textAlign: 'center',
  },
  value: {
    fontSize: theme.fontSizes.xxl,
    color: theme.colors.text.inverse,
    fontWeight: '700',
    textAlign: 'center',
  },
  hint: {
    marginTop: 4,
    fontSize: theme.fontSizes.xs,
    color: theme.colors.text.inverse,
    opacity: 0.8,
    textAlign: 'center',
  },
}); 